export var TransportDashboardTrendRange;
(function (TransportDashboardTrendRange) {
    TransportDashboardTrendRange["ThisWeek"] = "ThisWeek";
    TransportDashboardTrendRange["LastWeek"] = "LastWeek";
    TransportDashboardTrendRange["ThisMonth"] = "ThisMonth";
    TransportDashboardTrendRange["LastMonth"] = "LastMonth";
    TransportDashboardTrendRange["Last3Months"] = "Last3Months";
    TransportDashboardTrendRange["ThisYear"] = "ThisYear";
    TransportDashboardTrendRange["LastYear"] = "LastYear";
})(TransportDashboardTrendRange || (TransportDashboardTrendRange = {}));
